// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"46d058f6","117":"793494ef"}[chunkId] + ".chunk.css";
};